import { RouteRecordRaw } from 'vue-router'

const BaseLayout = () => import('@/layout/index.vue')
const Login = () => import('@/views/Login/index.vue')
const Home = () => import('@/views/Home/index.vue')
const IpcClassify = () => import('@/views/Home/IpcClassify/index.vue')
const PatentMining = () => import('@/views/PatentMining/index.vue') //专利挖掘

//专利图片编辑
const PatentImageEdit = () => import('@/views/PatentMining/PatentImageEdit.vue') //专利图片编辑
const PatentMiningDetail = () =>
  import('@/views/PatentMining/PatentMiningDetail.vue') //专利对比详情页面
const PatentDrafting = () => import('@/views/PatentDrafting/index.vue') //专利撰写
const Membership = () => import('@/views/Membership/index.vue') //会员中心
const PatentDraftingImageEdit = () =>
  import('@/views/PatentDrafting/PatentDraftingImageEdit.vue') //专利撰写-附图编辑（Draw.io）
const MolecularFormulaEditor = () =>
  import('@/views/PatentDrafting/MolecularFormulaEditor.vue') //专利撰写-分子式绘制（Ketcher）
const DetailedDescriptionPlanPage = () =>
  import('@/views/PatentDrafting/DetailedDescriptionPlanPage.vue') // 具体实施方式 · 撰写计划构建页
const PatentReply = () => import('@/views/PatentReply/index.vue') //答OA
const PromptLibrary = () => import('@/views/PromptLibrary/index.vue')
const TranslationProject = () => import('@/views/Translation/index.vue')
const TranslationNew = () => import('@/views/Translation/New.vue')
const TranslationWorkspace = () => import('@/views/Translation/Workspace.vue')
const TranslationImageEdit = () =>
  import('@/views/Translation/TranslationImageEdit.vue')
const TranslationPersonalKnowledge = () =>
  import('@/views/Translation/PersonalKnowledge.vue')
const SystemUserManage = () => import('@/views/System/UserManage/index.vue')
const SystemUserApply = () => import('@/views/System/UserApply/index.vue')
const SystemRoleManage = () => import('@/views/System/RoleManage/index.vue')
const SystemMenuManage = () => import('@/views/System/MenuManage/index.vue')
const SystemUserOprtLog = () => import('@/views/System/UserOprtLog/index.vue')
const SystemOperLog = () => import('@/views/System/OperLog/index.vue')
const SystemReleaseNoteManage = () =>
  import('@/views/System/ReleaseNoteManage/index.vue')
const SystemDataDashboard = () =>
  import('@/views/System/DataDashboard/index.vue')
const SystemUserStatistics = () =>
  import('@/views/System/UserStatistics/index.vue')
const SystemFeedbackManage = () =>
  import('@/views/System/FeedbackManage/index.vue')
const SystemPricePlanManage = () =>
  import('@/views/System/PricePlanManage/index.vue')
const SystemOrderManage = () => import('@/views/System/OrderManage/index.vue')
const SystemProjectManage = () =>
  import('@/views/System/ProjectManage/index.vue')
const SystemFigureLeadLinePresetManage = () =>
  import('@/views/System/FigureLeadLinePresetManage/index.vue')
const SystemFigurePrompt = () =>
  import('@/views/System/FigurePrompt/index.vue')
const SystemTranslationField = () =>
  import('@/views/System/TranslationField/index.vue')
const SystemTranslationKnowledge = () =>
  import('@/views/System/TranslationKnowledge/index.vue')
const SystemTranslationPrompt = () =>
  import('@/views/System/TranslationPrompt/index.vue')
const DataQuery = () => import('@/views/DataQuery/index.vue')

const baseRoute: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      notAuth: true,
      seoTitle:
        '柿子AI科技 - 知识产权全周期一站式智能辅助平台 | 专利挖掘·撰写·答OA',
      seoDescription:
        '柿子科技运用领先 AI 技术，提供专利挖掘、申请文件撰写、审查意见答复等知识产权全流程智能化解决方案，助力代理机构与企业高效完成专利工作。',
      seoKeywords:
        '柿子AI科技,专利AI,知识产权,专利挖掘,专利撰写,答OA,专利申请,AI专利助手'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { notAuth: true }
  },
  {
    path: '/ipc-classify',
    name: 'IpcClassify',
    component: IpcClassify,
    meta: {
      notAuth: true,
      title: '分类号判定'
    }
  },
  {
    path: '/',
    name: 'BaseLayout',
    component: BaseLayout,
    children: [
      {
        path: '/patent-mining',
        name: 'PatentMining',
        component: PatentMining,
        meta: { title: '专利挖掘' }
      },
      {
        path: 'PatentMiningDetail',
        name: 'PatentMiningDetail',
        component: PatentMiningDetail,
        meta: { title: '专利对比详情' }
      },
      {
        path: 'PatentImageEdit',
        name: 'PatentImageEdit',
        component: PatentImageEdit,
        meta: { title: '专利图片编辑' }
      },
      {
        path: '/patent-drafting',
        name: 'PatentDrafting',
        component: PatentDrafting,
        meta: { title: '专利撰写' }
      },
      {
        path: '/membership',
        name: 'Membership',
        component: Membership,
        meta: { title: '会员中心' }
      },
      {
        path: 'patent-drafting-image-edit',
        name: 'PatentDraftingImageEdit',
        component: PatentDraftingImageEdit,
        meta: { title: '专利图示编辑' }
      },
      {
        path: '/patent-drafting/:projectId/files/:ownerFileId/molecular-formula-editor/:formulaId?',
        name: 'MolecularFormulaEditor',
        component: MolecularFormulaEditor,
        meta: { title: '分子式绘制', hidden: true }
      },
      {
        path: '/patent-drafting/detailed-plan',
        name: 'PatentDraftingDetailedPlan',
        component: DetailedDescriptionPlanPage,
        meta: { title: '具体实施方式 · 撰写计划' }
      },
      {
        path: '/answer-oa',
        name: 'PatentReply',
        component: PatentReply,
        meta: { title: '答OA' }
      },
      {
        path: '/translation',
        name: 'Translation',
        redirect: { name: 'TranslationProject' },
        meta: { title: '专利翻译', hidden: true }
      },
      {
        path: '/translation/project',
        name: 'TranslationProject',
        component: TranslationProject,
        meta: { title: '翻译项目', prntName: '专利翻译' }
      },
      {
        path: '/translation/new',
        name: 'TranslationNew',
        component: TranslationNew,
        meta: { title: '新建翻译', prntName: '专利翻译', hidden: true }
      },
      {
        path: '/translation/project/:projectId',
        name: 'TranslationWorkspace',
        component: TranslationWorkspace,
        meta: { title: '翻译工作台', prntName: '专利翻译', hidden: true }
      },
      {
        path: '/translation/project/:projectId/image/:imageId',
        name: 'TranslationImageEdit',
        component: TranslationImageEdit,
        meta: { title: '翻译附图编辑', prntName: '专利翻译', hidden: true }
      },
      {
        path: '/translation/personal-knowledge',
        name: 'TranslationPersonalKnowledge',
        component: TranslationPersonalKnowledge,
        meta: { title: '个人知识库', prntName: '专利翻译', hidden: true }
      },
      {
        path: '/data-query',
        name: 'DataQuery',
        component: DataQuery,
        meta: { title: '数据查询' }
      },
      {
        path: '/data-query/mining',
        name: 'DataQueryMining',
        component: PatentMining,
        meta: { title: '挖掘项目', prntName: '数据查询', hidden: true }
      },
      {
        path: '/data-query/drafting',
        name: 'DataQueryDrafting',
        component: PatentDrafting,
        meta: { title: '撰写项目', prntName: '数据查询', hidden: true }
      },
      {
        path: '/data-query/oa-reply',
        name: 'DataQueryOaReply',
        component: PatentReply,
        meta: { title: '答OA项目', prntName: '数据查询', hidden: true }
      },
      {
        path: '/prompt-library',
        name: 'PromptLibrary',
        component: PromptLibrary,
        meta: { title: '提示语库' }
      },
      {
        path: '/system/operation',
        name: 'SystemOperation',
        redirect: { name: 'SystemUserApply' },
        meta: { title: '运营管理', hidden: true, prntName: '系统管理' }
      },
      {
        path: '/system/analytics',
        name: 'SystemAnalytics',
        redirect: { name: 'SystemDataDashboard' },
        meta: { title: '统计分析', hidden: true, prntName: '系统管理' }
      },
      {
        path: '/system/permission',
        name: 'SystemPermission',
        redirect: { name: 'SystemUserManage' },
        meta: { title: '权限管理', hidden: true, prntName: '系统管理' }
      },
      {
        path: '/system/log-audit',
        name: 'SystemLogAudit',
        redirect: { name: 'SystemOperLog' },
        meta: { title: '日志审计', hidden: true, prntName: '系统管理' }
      },
      {
        path: '/system/user-manage',
        name: 'SystemUserManage',
        component: SystemUserManage,
        meta: { title: '用户管理', prntName: '权限管理' }
      },
      {
        path: '/system/user-apply',
        name: 'SystemUserApply',
        component: SystemUserApply,
        meta: { title: '用户申请', prntName: '运营管理' }
      },
      {
        path: '/system/role-manage',
        name: 'SystemRoleManage',
        component: SystemRoleManage,
        meta: { title: '角色管理', prntName: '权限管理' }
      },
      {
        path: '/system/menu-manage',
        name: 'SystemMenuManage',
        component: SystemMenuManage,
        meta: { title: '菜单管理', prntName: '权限管理' }
      },
      {
        path: '/system/oper-log',
        name: 'SystemOperLog',
        component: SystemOperLog,
        meta: { title: '操作日志', prntName: '日志审计' }
      },
      {
        path: '/system/user-oprt-log',
        name: 'SystemUserOprtLog',
        component: SystemUserOprtLog,
        meta: { title: '系统日志', prntName: '日志审计' }
      },
      {
        path: '/system/release-note',
        name: 'SystemReleaseNoteManage',
        component: SystemReleaseNoteManage,
        meta: { title: '消息管理', prntName: '运营管理' }
      },
      {
        path: '/system/data-dashboard',
        name: 'SystemDataDashboard',
        component: SystemDataDashboard,
        meta: { title: '数据大盘', prntName: '统计分析' }
      },
      {
        path: '/system/user-statistics',
        name: 'SystemUserStatistics',
        component: SystemUserStatistics,
        meta: { title: '用户统计', prntName: '统计分析' }
      },
      {
        path: '/system/feedback',
        name: 'SystemFeedbackManage',
        component: SystemFeedbackManage,
        meta: { title: '问题清单', prntName: '运营管理' }
      },
      {
        path: '/system/price-plan',
        name: 'SystemPricePlanManage',
        component: SystemPricePlanManage,
        meta: { title: '收费配置', prntName: '运营管理' }
      },
      {
        path: '/system/order-manage',
        name: 'SystemOrderManage',
        component: SystemOrderManage,
        meta: { title: '订单管理', prntName: '运营管理' }
      },
      {
        path: '/system/project-manage',
        name: 'SystemProjectManage',
        component: SystemProjectManage,
        meta: { title: '项目列表', prntName: '统计分析' }
      },
      {
        path: '/system/figure-lead-line-presets',
        name: 'SystemFigureLeadLinePresetManage',
        component: SystemFigureLeadLinePresetManage,
        meta: { title: '预制引线管理', prntName: '运营管理' }
      },
      {
        path: '/system/figure-prompts',
        name: 'SystemFigurePrompt',
        component: SystemFigurePrompt,
        meta: { title: '附图提示语', prntName: '运营管理' }
      },
      {
        path: '/system/translation',
        name: 'SystemTranslation',
        redirect: { name: 'SystemTranslationField' },
        meta: { title: '翻译', hidden: true, prntName: '系统管理' }
      },
      {
        path: '/system/translation/field',
        name: 'SystemTranslationField',
        component: SystemTranslationField,
        meta: { title: '领域管理', prntName: '翻译' }
      },
      {
        path: '/system/translation/knowledge',
        name: 'SystemTranslationKnowledge',
        component: SystemTranslationKnowledge,
        meta: { title: '知识库', prntName: '翻译' }
      },
      {
        path: '/system/translation/prompt-text',
        name: 'SystemTranslationPrompt',
        component: SystemTranslationPrompt,
        meta: { title: '提示语修改', prntName: '翻译' }
      }
    ]
  }
]

export default baseRoute
